module.exports = __webpack_public_path__ + "img/bb_g3_ears-03.05627629.svg";